<template>
  <div class="f1 df fdrr jcsb wrapper">
    <!-- <SideBar v-bind:page="'profile'"/> -->
    <div class="page1 profile f1">


      <div v-if="$store.getters.emailVerified" class="profile-photo">
        <div class="profile-photo-inner df fdr">
          <div class="profile-photo-image posrel">
            <img
              v-if="$store.getters.userData.profileImage"
              class="profile-image"
              v-bind:src="$store.getters.userData.profileImage"
              alt=""
            >
            <img v-on:click="uploadPhotoStart()" src="/images/profile-icons/Edit-Profile-Pen.png" class="posabs edit-profile-icon" alt="">
            <input v-on:change="uploadPhotoContinue()" ref="fileInput" id="fileUploadButton" style="opacity,: 0; width: 0; height: 0; position: absolute;" type="file" />
          </div>
          <div class="profile-photo-details df fdc jcc">
            <p class="profile-top-name">
              {{ $store.getters.userData.fullName }}
            </p>
            <p class="profile-top-email">
              {{ $store.getters.userData.email }}
            </p>

            <p v-if="fileWrongTypeMessageOn" class="warning-type">Wrong type of file. Please use .jpg or .png.</p>

            <!--
            <div class="photo-buttons df fdr">
              <button v-on:click="deletePhoto()" class="button-form" v-bind:class="{'button-form-active': $store.getters.userData.profileImage}">
                Delete Photo
              </button>
              <button v-on:click="uploadPhotoStart()" class="button-form button-form-active">
                Upload Photo
              </button>
            </div> -->


          </div>
        </div>
      </div>



      <div class="basic-profile">
        <h4 class="mt0">Billing Info</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Name on Card</p>
            <input v-on:input="changesMade()" v-model="fullName" placeholder="Full Name" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>Card Number</p>
            <input v-mask="'####-####-####-####'" v-bind:placeholder="'**** **** **** ' + (last4 || '****')" v-on:input="changesMade()" v-model="cardNumber" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Expiration Date</p>
            <input v-on:input="changesMade()" v-mask="'##/####'" placeholder="10/2020" v-model="expiry" class="input1">
          </span>
          <span class="input-wrapper df fdc">
            <p>CVV</p>
            <input v-on:input="changesMade()" v-mask="'####'" placeholder="123" v-model="cvv" class="input1">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc w100i">
            <button v-on:click="updateBillingInfo0()" class="button-form" v-bind:class="{'button-form-active': profileChangesMade}">
              Update Billing Info
            </button>
          </span>
        </div>
      </div>


      <div class="basic-profile mt_1">
        <h4 class="mt0">Billing Address</h4>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Address</p>
            <input v-on:input="changesMade()" v-model="address" class="input1" type="text">
          </span>
          <span class="input-wrapper df fdc">
            <p>City</p>
            <input v-on:input="changesMade()" v-model="city" class="input1" type="text">
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc">
            <p>Country</p>
            <country-select v-on:input="changesMade()" v-model="country" :country="country" topCountry="US" class="input1" />
          </span>
          <span class="input-wrapper input-wrapper-row input-wrapper-inner df fdr">
            <span class="input-wrapper2 mb0i df fdc">
              <p>Province</p>
              <region-select v-on:input="changesMade()" v-model="province" :country="country" :region="province" class="input1 maxW" />
            </span>
            <span class="input-wrapper2 mb0i df fdc">
              <p>Zip/Postal Code</p>
              <input v-on:input="changesMade()" placeholder="" v-model="postalCode" size="10" class="input1" type="text">
            </span>
          </span>
        </div>
        <div class="form-row df fdr">
          <span class="input-wrapper df fdc w100i">
            <button v-on:click="updateBillingInfo()" class="button-form" v-bind:class="{'button-form-active': profileChangesMade}">
              Update Billing Address
            </button>
          </span>
        </div>
      </div>


    </div>
    <SideBarProfile v-bind:page="'billing'" v-bind:editingCompany="'no'"/>
  </div>
</template>

<script>
import SideBar from '../elements/SideBar'
import SideBarProfile from '../elements/SideBarProfile'
const axios = require('axios')
const common = require('../../util/common.js')

export default {
  name: 'DashboardBilling',
  data () {
    return {
      profileChangesMade: false,
      fileWrongTypeMessageOn: false,

      cardNumber: '',
      expiry: '',
      cvv: '',
      name: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postalCode: '',
      last4: '',
      fullName: '',
      sourceid: '',

      company: this.$store.getters.companyName,
      phone: this.$store.getters.userData.phone,
      email: this.$store.getters.userData.email,
      // address: this.$store.getters.userData.address,
      // city: this.$store.getters.userData.city,
      // country: this.$store.getters.userData.country,
      // province: this.$store.getters.userData.province,
      // postalCode: this.$store.getters.userData.postalCode,

      currentPassword: '',
      newPassword: '',
      newPasswordRepeat: ''
    }
  },
  props: [],
  components: {
    SideBarProfile,
    SideBar
  },
  methods: {
    changesMade () {
      this.profileChangesMade = true
    },
    deletePhoto () {
      var data = {uid: this.$store.getters.uid}
      this.$store.dispatch('deletePhoto', data).then(() => {
        console.log('After deleting photo')
      })
    },
    uploadPhotoStart () {
      console.log('start photo upload')
      this.$refs.fileInput.click()
    },
    uploadPhotoContinue () {
      console.log('continue uploading photo')
      var inputElement = document.getElementById('fileUploadButton')
      var fileList = inputElement.files
      if (fileList[0]) {
        console.log('THE FILE', fileList[0])
        if ((fileList[0].type == 'image/png') || (fileList[0].type == 'image/jpeg') || (fileList[0].type == 'image/jpg')) {
          var data = {
            file: fileList[0],
            uid: this.$store.getters.uid
          }
          console.log('file exists')
          this.fileWrongTypeMessageOn = false
          this.$store.dispatch('saveProfileImage', data).then(() => {
            // this.profileChangesMade = false
          })
        } else {
          this.fileWrongTypeMessageOn = true
          console.log('file is wrong type')
        }
      }
    },
    updateBillingInfo0 () {
      // return false
      var data = {
        uid: this.$store.getters.uid,
        cardNumber: this.cardNumber,
        expiry: this.expiry,
        cvv: this.cvv,
        name: this.fullName,
        address: this.address,
        city: this.city,
        province: this.province,
        country: this.country,
        postalCode: this.postalCode,
        last4: this.last4,
        fullName: this.fullName,
        sourceid: this.sourceid
      }

      if (this.profileChangesMade) {
        this.$store.dispatch('updateBillingInfo0', data).then(() => {
          this.profileChangesMade = false
        })
      }
    },
    updateBillingInfo () {
      // return false
      var data = {
        uid: this.$store.getters.uid,
        cardNumber: this.cardNumber,
        expiry: this.expiry,
        cvv: this.cvv,
        name: this.name,
        address: this.address,
        city: this.city,
        province: this.province,
        country: this.country,
        postalCode: this.postalCode,
        last4: this.last4,
        fullName: this.fullName,
        sourceid: this.sourceid
      }

      if (this.profileChangesMade) {
        this.$store.dispatch('updateBillingInfo', data).then(() => {
          this.profileChangesMade = false
        })
      }
    },
    getBillingDetailsFromProvider () {
      console.log('getBillingDetailsFromProvider')
      var _this = this

      var data = {
        uid: this.$store.getters.billingID
      }

      axios.get('/getexistingclient', {
        params: {
          format: 'json',
          data
        }
      })
      .then(function (response) {
        // console.log('response', response);
        console.log('RESPONSE 1', response)
        var user = response.data.billingData
        console.log('user', user, user.country, common)
        _this.fullName = user.name
        _this.address = user.address
        _this.city = user.city
        _this.province = user.province
        _this.country = common.default.getCountryName(user.country)
        // _this.country = user.country
        // _this.country = 'CA'
        _this.postalCode = user.postalCode
        _this.last4 = user.last4 || ''
        _this.sourceid = user.sourceid
      })
      .catch(function (error) {
        console.log('ERROR 1', error.response);
      })
      .then(function () {
        // always executed
      });
    }
  },
  created () {
    console.log('current user data', this.$store.getters.userData)
    document.onkeydown = checkKey;
    var _this = this
    function checkKey(e) {
      console.log('enter', e.keyCode == '13')
        e = e || window.event;
        if (e.keyCode == '13' && _this.profileChangesMade) {
        console.log('enter2')
            e.preventDefault()
            _this.saveProfile()
        }
    }

    setTimeout(()=>{this.getBillingDetailsFromProvider()}, 1500)

  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";
h4 {
  /*margin-top: 75px;*/
  font-size: 16px;
  font-family: 'Nexa';
  font-weight: 600;
  margin-bottom: 5px;
}

.wrapper {
  width: 100%;
  min-height: unset;
}


//
// Wrapper
//
.wrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row-reverse;
  padding-left: 50px;
  padding-right: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    flex-direction: column-reverse;
    padding-left: 0px;
    padding-right: 0px;
  }
}


//
// Page 1
//
.page1 {
  width: calc(100% - 274px);

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    width: 100%;
  }
}


//
// Form Row
//
.form-row {
  width: 100%;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    // display: block;
    flex-wrap: wrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
  }
}






.profile {
  // padding: 50px;
}

.input-wrapper2{
  width: calc(50% - 10px);
  min-width: 0px;
  flex-direction: column-reverse;
}
.input-wrapper{
  max-width: calc(50% - 40px);
  flex: 1;
  flex-direction: column-reverse;
}
.input-wrapper, .input-wrapper2 {
  margin-bottom: 10px;
  margin-right: 40px;

  & > p {
    color: #000000;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 25px;
    font-size: 12px;
    font-family: 'GG';
    font-weight: 300;
    padding-left: 4px;
    overflow: visible;
    white-space: nowrap;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
    width: auto;
    max-width: unset;
    margin-right: 0;

    // input & select
    input, select {
      display: block;
      width: 100%;
      max-width: unset;
    }
  }
}

.input-wrapper-row {
  -webkit-flex-direction: row;
  -moz-flex-direction: row;
  -ms-flex-direction: row;
  -o-flex-direction: row;
  flex-direction: row;
}

.input-wrapper-inner {
  flex: 1px;
  width: 50%;

  & > span {
    margin-right: 0;

    &:first-child {
      margin-right: 30px;
    }
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    flex: none;
    width: auto;

    // span first child
    > span:first-child {margin-right: 0px;}
  }
}

.delete-account-text {
  color: #000000;
  font-size: 18px;
  letter-spacing: 0.64px;
  line-height: 25px;
  margin-bottom: 30px;
}

.profile-photo-inner {
  /*border-radius: 8px;*/
  /*background-color: white;*/
  /*padding: 50px;*/

  margin-bottom: 15px;
  margin-right: 30px;
  /*box-shadow: 0 1px 4px 0 rgba(0,0,0,0.32);*/
}

.profile-photo-details {
  flex: 1;
  margin-left: 50px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    margin-left: 20px;
  }
}

.photo-buttons {
  & > button {
    &:first-child {
      margin-right: 40px;
    }
  }
}

.red-text {
  color: #d84647 !important;
}
.version {
  margin-top: 20px;
}
.maxW {
  max-width: 150px;
}
.warning-type {
  text-align: right;
  color: red;
  margin-top: 20px;
}


//
// Basic Profile
//
.basic-profile {
  max-width: 570px;
  margin-left: auto;
  margin-right: auto;

  // Responsive Style
  // @media max-width: 1024px
  @media(max-width: 1024px) {
    max-width: unset;
  }
}


.edit-profile-icon {
  width: 24px;
  height: 24px;
  background-color: $grey2;
  border-radius: 50%;
  object-fit: none;
  right: 0;
  top: 0;
}
.profile-top-name {
  font-family: 'Nexa';
  font-weight: 600;
  font-size: 24px;
  color: $grey2;
  margin-bottom: 6px;
}
.profile-top-email {
  font-family: 'GG';
  font-weight: 400;
  font-size: 16px;
  color: $grey2;
}
.button-form {
  margin-top: 25px;
}
.change-password {
  margin-top: 50px;
}
.mt_1 {
  margin-top: 50px;
}
</style>
